import { useParams } from 'react-router-dom';
import BookingPageWrapper from '@/components/booking/BookingPageWrapper';

export default function BranchPage() {
  const { businessId, branchId } = useParams<{ businessId: string; branchId: string }>();
  
  return (
    <div suppressHydrationWarning>
      <BookingPageWrapper 
        businessId={businessId!} 
        branchId={branchId!} 
      />
    </div>
  );
}